import React from 'react';
import renderUtils from '../../helpers/renderUtils';

const DatesRange = ({ startDate, endDate, year, details = true }) => {
  return (
    <div className="mb-2">
      <strong>
        {renderUtils.formatDate(startDate, year)} -{' '}
        {renderUtils.formatDate(endDate, year)}
      </strong>
      <br />
      {details && <small className="text-muted">Przyjazd - Wyjazd</small>}
    </div>
  );
};

export default DatesRange;
